const getters = {
  fullLoading: (state) => state.app.fullLoading,
  loadingText: (state) => state.app.loadingText,
  userInfo: (state) => state.app.userInfo,
  staffId: (state) => state.app.staffId,
  isCollapse: (state) => state.app.isCollapse,
  dictMap: (state) => state.dict.dictMap,
};

export default getters;
